import { getLocalStorageData } from '../../../utils/helper';
import { APP_API_URL_V2 } from '../../../utils/xhr-instance';
import { axiosInstanceV2 } from '../../axios';

export async function getInvoiceGeneral() {
	const API_URL = `${APP_API_URL_V2}/settings/sales/invoice/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function UpdateInvoiceGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/sales/invoice/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function getSalesOrderGeneral() {
	const API_URL = `${APP_API_URL_V2}/settings/sales/sales-order/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function UpdateSalesOrderGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/sales/sales-order/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function getDeliveryChallanGeneral() {
	const API_URL = `${APP_API_URL_V2}/settings/sales/delivery-challan/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function UpdateDeliveryChallanGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/sales/delivery-challan/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function getShipmentGeneral() {
	const API_URL = `${APP_API_URL_V2}/settings/sales/shipment/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function UpdateShipmentGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/sales/shipment/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}

export async function getCreditNoteGeneral() {
	const API_URL = `${APP_API_URL_V2}/settings/sales/credit-note/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.get(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data.data)
		.catch((error) => error?.response?.data);
}

export async function UpdateCreditNoteGeneral(data) {
	const API_URL = `${APP_API_URL_V2}/settings/sales/credit-note/general`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
